import { CamposAlterarSenha } from './types';

export const initialValues: CamposAlterarSenha = {
  senhaAtual: '',
  novaSenha: '',
  repetirNovaSenha: '',
};
